<template>    
  <v-form>      
          
  </v-form>  
</template>
<script>
  import { mapGetters } from 'vuex' 
  export default {    
    name: 'MapPanelProperties',    
    props:['value'],
    data() {
      return {   
      }
    },
   computed: {
       ...mapGetters([
        ])        
    },
    methods: {
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>

</style>
